<template>
  <div
    class="font-normal text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] leading-6 md:leading-7 lg:leading-8"
    :class="hasPast ? pastClass : futureClass"
  >
    <div
      v-for="(item, index) in eventTimeLocation"
      :key="item.id || index"
      :class="{ 'mt-2': index > 0 }"
    >
      <div v-if="item.location" class="flex items-center">
        <img class="h-full" :src="eventLocationIcon" alt="location icon" />
        <p class="ml-1">
          {{ item.location }}
        </p>
      </div>
      <div v-if="item.time" class="flex items-center">
        <img class="h-full" :src="eventTimeIcon" alt="time icon" />
        <p class="ml-1">
          {{ item.time }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasPast: {
      type: Boolean,
      default: false,
    },
    eventTimeLocation: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pastClass: 'text-[#7C8A9C]',
      futureClass: 'text-[#4D5766]',
    };
  },
  computed: {
    eventTimeIcon() {
      return this.hasPast
        ? '/assets/icons/calendar/event-time-past.svg'
        : '/assets/icons/calendar/event-time-future.svg';
    },
    eventLocationIcon() {
      return this.hasPast
        ? '/assets/icons/calendar/event-location-past.svg'
        : '/assets/icons/calendar/event-location-future.svg';
    },
  },
};
</script>
